import { render, staticRenderFns } from "./Gs.vue?vue&type=template&id=11c745da&scoped=true&"
import script from "./Gs.vue?vue&type=script&lang=ts&"
export * from "./Gs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c745da",
  null
  
)

export default component.exports